module.exports = __webpack_public_path__ + "icofont.ea6b50ee81ded0716b21.eot";


//////////////////
// WEBPACK FOOTER
// E:/Git_new/IVMS_PRO/web/src/assets/icon/icofont/fonts/icofont.eot?v=1.0.0-beta
// module id = ../../../../../src/assets/icon/icofont/fonts/icofont.eot?v=1.0.0-beta
// module chunks = styles